<template>
  <v-main>
    <v-container grid-list-md fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md5>
          <v-card class="elevation-12">

            <v-toolbar dark color = "primary">
              <v-toolbar-title>{{$t("Attention needed")}}</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              {{$t("The user is not fully configured.")}}
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="success" to="/Users">{{$t("Ok")}}</v-btn>
            </v-card-actions>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
// This view is used when a user is missing some configuration e.g. an email.
export default {
}
</script>
